<template>
  <div
    class="container"
    :style="[bgUrl ? { 'background-image': 'url(' + bgUrl + ')' } : {}]"
  >
    <Menu />
    <div class="center">
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
export default {
  name: "CenterLayout",
  components: {
    Menu,
  },
  data() {
    return {
      bgUrl: "",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.centerBackground) {
      this.bgUrl = tenantConfig.themeConfig.centerbackground;
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: linear-gradient(
    180deg,
    rgb(59, 143, 238) 7%,
    rgb(155, 216, 243) 100%
  );
  .center {
    width: 1200px;
    margin: auto;
  }
}
</style>